import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import ResultPage from '@blade-sxp/data-mining/pages/companions/components/result/result-page.vue';
import FilterBar from '@blade-sxp/data-mining/pages/companions/components/result/result.vue';
let AlarmCenter = class AlarmCenter extends Vue {
    allNum;
    pageSize;
    selectedImg;
    imgList;
    resultType;
    tagList;
    maxHeight;
    isRoute;
    isWidth;
    loading;
    isShow = false;
    distance = '';
    isCheck = false;
    mounted() {
        window.addEventListener('scroll', this.handleScrollx, true);
    }
    // 切换分页
    changePageSize(page) {
        this.$emit('changePageSize', page);
        // this.pageNum = page;
        // this.initData();
    }
    filter() {
        this.isShow = !this.isShow;
    }
    showPopover() {
        this.$emit('show-popover');
    }
    // 清空全部轨迹
    clearAlltrack() {
        this.$emit('clear-alltrack');
    }
    // 删除一个轨迹
    deleteImg(imageId) {
        this.$emit('delete-img', imageId);
    }
    selectable() {
        this.isCheck = !this.isCheck;
        this.$emit('selectable', this.isCheck);
    }
    changeTrack(val, deviceVal, index) {
        this.$emit('change-track', val, deviceVal, index);
    }
    // 打开详情页
    openDetail(data, index) {
        this.$emit('open-detail', data, index);
    }
    openTrack() {
        this.$emit('open-track');
    }
    handleScrollx(e) {
        const elm = e.target;
        if (elm.className === 'main-container') {
            const top = elm.scrollTop;
            if (top <= this.maxHeight) {
                this.isShow = false;
                this.distance = '';
            }
            else {
                this.isShow = true;
                this.distance = 'distance';
            }
        }
    }
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScrollx, true);
    }
};
__decorate([
    Prop({ default: 0 })
], AlarmCenter.prototype, "allNum", void 0);
__decorate([
    Prop()
], AlarmCenter.prototype, "pageSize", void 0);
__decorate([
    Prop()
], AlarmCenter.prototype, "selectedImg", void 0);
__decorate([
    Prop()
], AlarmCenter.prototype, "imgList", void 0);
__decorate([
    Prop({ default: true })
], AlarmCenter.prototype, "resultType", void 0);
__decorate([
    Prop()
], AlarmCenter.prototype, "tagList", void 0);
__decorate([
    Prop({ default: 60 })
], AlarmCenter.prototype, "maxHeight", void 0);
__decorate([
    Prop({ default: true })
], AlarmCenter.prototype, "isRoute", void 0);
__decorate([
    Prop({ default: false })
], AlarmCenter.prototype, "isWidth", void 0);
__decorate([
    Prop({ default: false })
], AlarmCenter.prototype, "loading", void 0);
AlarmCenter = __decorate([
    Component({
        name: 'SearchFrom',
        components: { FilterBar, ResultPage },
        i18n: {},
    })
], AlarmCenter);
export default AlarmCenter;
